export default '/build/bd5c8518.svg'